module.exports = __webpack_public_path__ + "26aaea3461b10b21f1d586ffc2c06b43.svg";